import * as React from 'react';
import { Form, Formik } from 'formik';
import { REPORT_TYPE_SERVER_TO_CLIENT_MAPPING } from '../../../../../../../consts/report';
import { getStartDateForSchoolYear } from '../../../../../../../helpers/calendar/calendar';
import { ReportActions, ReportDateRange, ReportDescription, ReportSection, ReportToggle, ReportToggleList } from 'Src/views/GenericView/AdminView/TeamsAndEvents/Events/SchoolEventView/Reports/ReportFormUi';

interface Props {
  onCloseClick: () => void;
  onSubmit: (data: any, reportType: string) => void;
}

const startOfDay = (date: Date) => new Date(new Date(date).setHours(0, 0, 1, 0));
const endOfDay = (date: Date) => new Date(new Date(date).setHours(23, 59, 59, 999));
const schoolYearRange = () => {
  const now = new Date();
  return { from: startOfDay(getStartDateForSchoolYear(now)), to: endOfDay(now) };
};

export function SelectedStudentTargetCompletionReportForm(props: Props) {
  const range = schoolYearRange();
  const initialValues = {
    dateFrom: range.from,
    dateTo: range.to,
    isShowCompleted: true,
    isShowUncompleted: true
  };

  return (
    <Formik initialValues={initialValues} onSubmit={values => props.onSubmit(values, REPORT_TYPE_SERVER_TO_CLIENT_MAPPING.SELECTED_STUDENT_TARGET_COMPLETION)}>
      {({ values, setFieldValue }) => (
        <Form className="eReportForm">
          <div className="eReportForm__scroll">
          <ReportDescription>Review selected students' progress against individual targets across activities.</ReportDescription>
          <ReportSection number={1} title="Reporting period" hint="Choose the date range included in the report." required>
            <ReportDateRange
              dateFrom={values.dateFrom}
              dateTo={values.dateTo}
              onChangeFrom={date => {
                setFieldValue('dateFrom', date);
                if (values.dateTo && values.dateTo < date) setFieldValue('dateTo', date);
              }}
              onChangeTo={date => setFieldValue('dateTo', date)}
            />
          </ReportSection>

          <ReportSection number={2} title="Targets" hint="Choose which target states appear in the report."><ReportToggleList>
            <ReportToggle name="isShowCompleted" label="Show completed targets" hint="Show targets that have been marked as completed." value={values.isShowCompleted} onChange={value => setFieldValue('isShowCompleted', value)} />
            <ReportToggle name="isShowUncompleted" label="Show incomplete targets" hint="Show targets that have not been completed yet." value={values.isShowUncompleted} onChange={value => setFieldValue('isShowUncompleted', value)} />
          </ReportToggleList></ReportSection>
          </div>
          <ReportActions onCancel={props.onCloseClick} disabled={!values.isShowCompleted && !values.isShowUncompleted} />
        </Form>
      )}
    </Formik>
  );
}
